
	export default {
		mixins: [],
		props: [],
		components: {},
		data: function () {
			return {
				experiences: [],
				standard: {},
				edit_product: false,
				progressBarColor: "",
			};
		},
		computed: {

      payment_provider_id() {
        if (this.$store.getters.getAccount.PaymentProviderAccount) {
          return this.$store.getters.getAccount.PaymentProviderAccount.payment_provider_id;
        }
        return false;
      },

      hasBillingPageJouney(){
        return this.payment_provider_id === 8; // freedompay
      },

      previousRoute() {

        if(this.$route.name === 'payment' && this.hasBillingPageJouney) {
          return 'billing'
        }else{
          return this.$route.name === 'delivery' ? 'basket' : 'delivery';
        }

      },

      previousRouteHref() {
        return this.$router.resolve({ name: this.previousRoute }).href;
      },
			cssVars() {
				return {
					"--bg-color": this.styleMe(
						"vanilla",
						"StoreFront",
						"background"
					)[1]["background-color"],
				};
			},
		},
		created: function () {},
		mounted: function () {},
		methods: {},
	};
